/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { Wizard_CustomerFragmentDoc } from './Wizard.graphql';
export type ClaimDisplayModal_CustomerFragment = { __typename: 'Customer', id: string, displayCount: number, waveSubscriptionUsage?: number | null, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export const ClaimDisplayModal_CustomerFragmentDoc = gql`
    fragment ClaimDisplayModal_customer on Customer {
  id
  ...Wizard_customer
}
    ${Wizard_CustomerFragmentDoc}`;